module.exports = __webpack_public_path__ + "img/newspappers.e2ef0d6e.png";